const routes = [
  {
    path: '/google-reserve',
    name: 'google-reserve',
    component: () => import(/* webpackChunkName: "ReserveWithGooglePage" */ './views/ReserveWithGooglePage.vue'),
  },
];

export default routes;
